import React, { useState, useEffect } from "react";
import { DocRenderer } from "react-doc-viewer";
import mammoth from "mammoth";
import { CircularProgress, Typography } from "@mui/material";

const DOCXViewer: DocRenderer = ({ mainState: { currentDocument } }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [content, setContent] = useState<string>("");

  useEffect(() => {
    const fetchAndParseDocx = async () => {
      console.log("currentDocument: ", currentDocument);
      if (!currentDocument?.uri) {
        setError("No document provided.");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await fetch(currentDocument.uri);
        if (!response.ok) throw new Error("Failed to fetch document.");

        const arrayBuffer = await response.arrayBuffer();

        // Convert DOCX to HTML
        const result = await mammoth.convertToHtml({ arrayBuffer });
        setContent(result.value);

        // Handle any warnings
        if (result.messages.length > 0) {
          console.warn("Conversion warnings:", result.messages);
        }

        setError(null);
      } catch (err) {
        setError("Error loading document.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAndParseDocx();
  }, [currentDocument?.uri]);

  return (
    <div className="tw-p-4 tw-rounded-lg tw-bg-white tw-shadow-md tw-w-full">
      <Typography variant="h6" className="tw-text-xl tw-font-bold tw-mb-4">
        Document Preview
      </Typography>

      {loading && (
        <div className="tw-flex tw-justify-center tw-items-center tw-h-40">
          <CircularProgress />
        </div>
      )}

      {error && (
        <Typography className="tw-text-red-500 tw-font-semibold tw-text-center">
          {error}
        </Typography>
      )}

      {!loading && !error && content && (
        <div
          className="tw-prose tw-max-w-none tw-p-6 tw-border tw-border-gray-200 tw-rounded-lg tw-shadow-sm"
          dangerouslySetInnerHTML={{ __html: content }}
          style={{
            maxHeight: "600px",
            overflowY: "auto",
            backgroundColor: "#ffffff",
          }}
        />
      )}

      {!loading && !error && !content && (
        <Typography className="tw-text-gray-500 tw-text-center">
          No content available.
        </Typography>
      )}
    </div>
  );
};

DOCXViewer.fileTypes = ["doc", "docx"];
DOCXViewer.weight = 1;

export default DOCXViewer;
